/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Complete_ToastInputs */

const en_ccsl_export_complete_toast = /** @type {(inputs: Ccsl_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export Complete`)
};

const fr_ccsl_export_complete_toast = /** @type {(inputs: Ccsl_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportation terminee`)
};

const de_ccsl_export_complete_toast = /** @type {(inputs: Ccsl_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export abgeschlossen`)
};

const it_ccsl_export_complete_toast = /** @type {(inputs: Ccsl_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esportazione completata`)
};

const ru_ccsl_export_complete_toast = /** @type {(inputs: Ccsl_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт завершен`)
};

const es_ccsl_export_complete_toast = /** @type {(inputs: Ccsl_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportación completa`)
};

const zh_cn2_ccsl_export_complete_toast = /** @type {(inputs: Ccsl_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出完成`)
};

const ja_ccsl_export_complete_toast = /** @type {(inputs: Ccsl_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エクスポート完了`)
};

const hi_ccsl_export_complete_toast = /** @type {(inputs: Ccsl_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`निर्यात पूर्ण`)
};

const pt_pt2_ccsl_export_complete_toast = /** @type {(inputs: Ccsl_Export_Complete_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportação concluída`)
};

/**
* | output |
* | --- |
* | "Export Complete" |
*
* @param {Ccsl_Export_Complete_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_complete_toast = /** @type {((inputs?: Ccsl_Export_Complete_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Complete_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_complete_toast(inputs)
	if (locale === "de") return de_ccsl_export_complete_toast(inputs)
	if (locale === "it") return it_ccsl_export_complete_toast(inputs)
	if (locale === "ru") return ru_ccsl_export_complete_toast(inputs)
	if (locale === "es") return es_ccsl_export_complete_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_complete_toast(inputs)
	if (locale === "ja") return ja_ccsl_export_complete_toast(inputs)
	if (locale === "hi") return hi_ccsl_export_complete_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_complete_toast(inputs)
	return en_ccsl_export_complete_toast(inputs)
});